<template>
  <div
    class="mt-8">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                color="#718EBF"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                color="#718EBF"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                color="#718EBF"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                color="#718EBF"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <v-select
                filled
                rounded
                dense

                color="#718EBF"
                placeholder="Contoh. 2023"

                hide-details

                :items="years"
                :item-color="set_color"

                v-model="filter.year"
                style="border-radius: 10px;">
              </v-select>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          v-if="dialog.form"
          width="calc(100vw - 100px)"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Tambah Pengajuan
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <v-row>
                    <v-col class="py-0" cols="4">
                      <div class="mb-2">
                        <div class="mb-2 font_weight_600 fs-13 black_one">
                          Judul
                        </div>
                        <div>
                          <ValidationProvider
                            :name="`Judul`" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              rounded
                              dense
                              autofocus
                              outlined
                              hide-details
        
                              :color="set_color"
                              placeholder="Judul"
                              :error-messages="errors"
        
                              v-model="form.title"
                              
                              required
                              style="border-radius: 6px !important;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.title !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </div>
                      </div>
                    </v-col>
                    <v-col class="py-0" cols="4">
                      <div class="mb-2">
                        <div class="mb-2 font_weight_600 fs-13 black_one">
                          Tanggal
                        </div>
                        <!-- <v-menu
                          v-model="mrnu3"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                          >
                          <template v-slot:activator="{ on, attrs }"> -->
                            <ValidationProvider 
                              :name="`Tanggal`" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <v-text-field
                                v-model="form.due_date"
                                
                                v-on:keyup.enter="save()"
                                
                                
                                outlined
                                dense
                                
                                :color="set_color"
                                placeholder="Tanggal"
          
                                hide-details
                              
          
                                :error-messages="errors"
                                required
                                style="border-radius: 6px !important;"
                                type="date"
                                locale="id"
                                >
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.due_date !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          <!-- </template>
                          <v-date-picker
                            v-model="form.date"
                            @input="mrnu3 = false"
                          ></v-date-picker>
                        </v-menu> -->
                      </div>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-6"></v-divider>
                  <v-row>
                    <v-col cols="12">
                      <div class="d-flex align-center">
                        <div class=" px-2" style="width: 100%;">
                          <div class="fs-18 font-weight-bold black_one">
                            Data Barang Pengajuan
                          </div>
  
                          <div class="mt-2">
                            <v-btn
                              elevation="0"
                              color="#240087"
                              @click="form.items_arr.push({ item_name: '', item_qty: '', item_nominal: '', item_note: '' });"
                              class="fs-11 white--text text-capitalize" style="border-radius: 6px;">
                              <v-icon
                                size="18">
                                mdi-plus
                              </v-icon>
  
                              <span
                                class="ml-2">
                                Tambah 
                              </span>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                      <v-card flat>
                        <v-card-text class="py-0 px-2">

                          <div class="view mt-1">
                            <div class="wrapper_add">
                              <table style="border: 1px solid #ededed; width: 100%;" class="table">
                                <tr>
                                  <th style="font-size: 14px; z-index: 1; width: 50px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">Aksi</th>
                                  <th style="font-size: 14px; z-index: 1; width: 210px; min-width: 210px; max-width: 210px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Nama</th>
                                  <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                    <div class="d-flex align-center">
                                      <div>
                                        Qty
                                      </div>
                                      <!-- <div class="ml-auto">
                                        {{ add_total_debit | price }}
                                      </div> -->
                                    </div>
                                  </th>
                                  <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                    <div class="d-flex align-center">
                                      <div>
                                        Nominal
                                      </div>
                                      <!-- <div class="ml-auto">
                                        {{ add_total_kredit | price }}
                                      </div> -->
                                    </div>
                                  </th>
                                  <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                    <div class="d-flex align-center">
                                      <div>
                                        Keterangan
                                      </div>
                                      <!-- <div class="ml-auto">
                                        {{ add_total_kredit | price }}
                                      </div> -->
                                    </div>
                                  </th>
                                </tr>
                                <tr v-for="(item, index) in form.items_arr" :key="index">
                                  <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 60px; min-width: 60px; max-width: 60px; text-align: center;">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          v-bind="attrs"
                                          v-on="on"
                                          min-width="36"
                                          rounded
                                          @click="form.items_arr.splice(index, 1);"
                                          color="red"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 6px;">
                                          <v-icon small>mdi-trash-can-outline</v-icon>
                                          
                                        </v-btn>
                                      </template>
              
                                      <span>Hapus</span>
                                    </v-tooltip>
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; width: 100%; border-left: none; padding: 8px 12px; text-align: left;">
                                    <ValidationProvider
                                      :name="`Nama Barang data Ke ${index}`" 
                                      :rules="`required`" 
                                      v-slot="{ errors }">
                                      <v-text-field
                                            
                                        
                                        rounded
                                        dense
                                        outlined
                                        hide-details
                  
                                        :color="set_color"
                                        placeholder="Nama Barang"
                                        :error-messages="errors"
                  
                                        v-model="item.item_name"
                                        
                                        required
                                        style="border-radius: 10px;">
                                        <template v-slot:append-outer>
                                          <div v-if="errors.length > 0">
                                            <v-tooltip top color="#ff5252">
                                              <template v-slot:activator="{ on }">
                                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                              </template>
                                              
                                              {{ errors[0] }}
                                            </v-tooltip>
                                          </div>
                                          
                                          <!-- <div v-if="item.qty !== '' && valid">
                                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                                          </div> -->
                                        </template>
                                      </v-text-field>
                                    </ValidationProvider>
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150px; max-width: 150px; padding: 8px 12px; text-align: right;">
                                    <ValidationProvider
                                      :name="`Qty data Ke ${index}`" 
                                      :rules="`min_value:0`" 
                                      v-slot="{ errors }">
                                      <v-currency-field
                                            
                                        
                                        rounded
                                        dense
                                        outlined
                                        hide-details
                  
                                        :color="set_color"
                                        placeholder="Qty"
                                        :error-messages="errors"
                  
                                        v-model="item.item_qty"
                                        
                                        required
                                        style="border-radius: 10px;">
                                        <template v-slot:append-outer>
                                          <div v-if="errors.length > 0">
                                            <v-tooltip top color="#ff5252">
                                              <template v-slot:activator="{ on }">
                                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                              </template>
                                              
                                              {{ errors[0] }}
                                            </v-tooltip>
                                          </div>
                                          
                                          <!-- <div v-if="item.item_qty !== '' && valid">
                                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                                          </div> -->
                                        </template>
                                      </v-currency-field>
                                    </ValidationProvider>
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150px; max-width: 150px; padding: 8px 12px; text-align: right;">
                                    <ValidationProvider
                                      :name="`Nominal data Ke ${index}`" 
                                      :rules="`min_value:0`" 
                                      v-slot="{ errors }">
                                      <v-currency-field
                                            
                                        
                                        rounded
                                        dense
                                        outlined
                                        hide-details
                  
                                        :color="set_color"
                                        placeholder="Nominal"
                                        :error-messages="errors"
    
                                        
                  
                                        v-model="item.item_nominal"
                                        
                                        required
                                        style="border-radius: 10px;">
                                        <template v-slot:append-outer>
                                          <div v-if="errors.length > 0">
                                            <v-tooltip top color="#ff5252">
                                              <template v-slot:activator="{ on }">
                                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                              </template>
                                              
                                              {{ errors[0] }}
                                            </v-tooltip>
                                          </div>
                                          
                                          <!-- <div v-if="item.item_nominal !== '' && valid">
                                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                                          </div> -->
                                        </template>
                                      </v-currency-field>
                                    </ValidationProvider>
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 400px; min-width: 400px; max-width: 400px; padding: 8px 12px; text-align: left;">
                                    <ValidationProvider
                                      :name="`Keterangan data Ke ${index}`"
                                      :rules="`required`"
                                      v-slot="{ errors }">
                                      <v-textarea
                                        rounded
                                        dense
                                        outlined
                                        hide-details
                                        rows="2"
                  
                                        :color="set_color"
                                        placeholder="Keterangan"
                                        :error-messages="errors"
                  
                                        v-model="item.item_note"
                                        
                                        required
                                        style="border-radius: 10px;">
                                        <template v-slot:append-outer>
                                          <div v-if="errors.length > 0">
                                            <v-tooltip top color="#ff5252">
                                              <template v-slot:activator="{ on }">
                                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                              </template>
                                              
                                              {{ errors[0] }}
                                            </v-tooltip>
                                          </div>
                                          
                                          <!-- <div v-if="item.item_description !== '' && valid">
                                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                                          </div> -->
                                        </template>
                                      </v-textarea>
                                    </ValidationProvider>
                                  </td>
                                </tr>
                              </table>
                              <v-card-text
                                v-if="form.items_arr.length === 0"
                                class="pb-0 my-4" style="height: calc( 100vh - 600px ); display: flex; align-items: center; justify-content: center;">
                                <div class="text-center">
                                  <v-img 
                                    class="mx-auto"
                                    contain
                                    alt="vuetify"
                                    :width="90"
                                    :height="90"
                                    :src="require('@/assets/image/empty.png')">
                                    <!-- <template v-slot:placeholder>
                                      <v-row
                                        class=" "
                                        align="center"
                                        justify="center">
                                        <v-progress-circular 
                                          indeterminate 
                                          :color="set_color">
                                        </v-progress-circular>
                                      </v-row>
                                    </template> -->
                                  </v-img>
                                  <div class="mt-3 fs-16">
                                    Belum Ada Barang Pengajuan
                                  </div>
                                </div>
                              </v-card-text>
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-form>
              </ValidationObserver>

            </v-card-text>
            
            <v-divider 
            class="mt-2"
            style="border-top: 2px dashed #e0e0e0;"/>
            
            <v-card-actions
            class="pa-4">
              <div v-if="message.error.length > 0"
                class="text-left">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false;"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.detail"
          @keydown.esc="dialog.detail = false"
          :fullscreen="dialog.fullscreen"
          v-if="dialog.detail"
          width="calc(100vw - 100px)"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Detail Pengajuan
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false; detail = {};"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text
              v-if="process.detail" 
              class="pb-0 my-4" 
              style="height: calc(800px); display: flex; align-items: center; justify-content: center;">
              <div class="text-center">
                <div class="mb-4 title">
                  Mohon Tunggu . . .
                </div>

                <v-progress-linear
                  :color="set_color"
                  indeterminate
                  rounded
                  height="10">
                </v-progress-linear>
              </div>
            </v-card-text>

            <v-card-text 
              class="py-0 my-4" v-if="!process.detail && Object.keys(detail).length > 0">
              <table>
                <tr>
                  <td class="font_weight_600 fs-13 py-1">
                    Nama Pengajuan
                  </td>
                  <td style="width: 50px;" class="text-center py-1">
                    :
                  </td>
                  <td class="font-weight-bold fs-13 py-1">
                    {{ detail.title }}
                  </td>
                </tr>
                <tr>
                  <td class="font_weight_600 fs-13 py-1">
                    Tanggal Jatuh Tempo
                  </td>
                  <td style="width: 50px;" class="text-center py-1">
                    :
                  </td>
                  <td class="font-weight-bold fs-13 py-1">
                    {{ detail.due_date | date }}
                  </td>
                </tr>
                <tr>
                  <td class="font_weight_600 fs-13 py-1">
                    Status
                  </td>
                  <td style="width: 50px;" class="text-center py-1">
                    :
                  </td>
                  <td class="font-weight-bold fs-13 py-1">
                    {{ detail.status === 'pengajuan' ? 'Pengajuan Awal' : detail.status === 'approval1' ? 'Disetujui Supervisor' : detail.status === 'ditolak1' ? 'Ditolak Supervisor' : detail.status === 'approval2' ? 'Pengajuan Disetujui General Manager' : detail.status === 'ditolak2' ? 'Pengajuan Ditolak General Manager' : detail.status === 'approval3' ? 'Pembayaran Disetujui Finance Manager' : detail.status === 'ditolak3' ? 'Pembayaran Ditolak Finance Manager' : detail.status === 'terupdate' ? 'Sudah Update Harga & Pilih Supplier' : detail.status === 'penerimaan' ? 'Diterima Oleh Gudang' : detail.status === 'coa' ? 'Pengisian CoA Oleh Kasir' : detail.status === 'verifikasi' ? 'Diverifikasi Oleh Akunting' : detail.status === 'approval4' ? 'Pembayaran Disetujui General Manager' : detail.status === 'ditolak4' ? 'Pembayaran Ditolak General Manager' : 'Print' }}
                  </td>
                </tr>
                    <!-- <tr>
                      <td class="font_weight_600 fs-13 py-1">
                        Status
                      </td>
                      <td style="width: 50px;" class="text-center py-1">
                        :
                      </td>
                      <td class="font-weight-bold fs-13 py-1">
                        <v-chip
                          :color="detail.status === 'terupdate' ? 'primary' : detail.status === 'ditolak' ? 'red' : 'green'"
                          class="white--text">
                          {{ detail.status === 'terupdate' ? 'Pengajuan' : detail.status === 'ditolak2' ? 'Ditolak' : 'Disetujui'}}
                        </v-chip>
                      </td>
                    </tr> -->
                    <tr>
                      <td class="font_weight_600 fs-13 py-1" style="width: 150px;">
                        Tipe Pembayaran
                      </td>
                      <td style="width: 50px;" class="text-center py-1">
                        :
                      </td>
                      <td class="font-weight-bold fs-13 py-1">
                        {{ detail.method_payment === '' ? '-' : detail.method_payment }}
                      </td>
                    </tr>
                <tr v-if="detail.voucher_number !== ''">
                  <td class="font_weight_600 fs-13 py-1">
                    Nomor Voucher
                  </td>
                  <td style="width: 50px;" class="text-center py-1">
                    :
                  </td>
                  <td class="font-weight-bold fs-13 py-1">
                    {{ detail.voucher_number }}
                  </td>
                </tr>
                <tr v-if="detail.voucher_number !== ''">
                  <td class="font_weight_600 fs-13 py-1">
                    Tanggal Voucher
                  </td>
                  <td style="width: 50px;" class="text-center py-1">
                    :
                  </td>
                  <td class="font-weight-bold fs-13 py-1">
                    {{ detail.voucher_date | date }}
                  </td>
                </tr>
                <!-- <tr>
                  <td class="font_weight_600 fs-13 py-1">
                    Coa
                  </td>
                  <td style="width: 50px;" class="text-center py-1">
                    :
                  </td>
                  <td class="font-weight-bold fs-13 py-1">
                    <span v-for="(i, l) in detail.coa" :key="l">
                      <div>
                        {{ i.pengajuan_coa_coa_name }}({{ i.pengajuan_coa_coa_number }})
                      </div>
                    </span>
                  </td>
                </tr> -->
              </table>
              <div class="view mt-1" v-if="detail.coa !== null && detail.coa.length > 0">
                <div class="fs-14 mb-1 font-weight-bold">
                  Data CoA
                </div>
                <div class="wrapper_add">
                  <table style="border: 1px solid #ededed; width: 100%;" class="table">
                    <tr>
                      <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">No Akun</th>
                      <th style="font-size: 14px; z-index: 1; width: 210px; min-width: 210px; max-width: 210px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Nama Akun</th>
                      <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                        <div class="d-flex align-center">
                          <div>
                            Debit
                          </div>
                          <!-- <div class="ml-auto">
                            {{ add_total_debit | price }}
                          </div> -->
                        </div>
                      </th>
                      <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                        <div class="d-flex align-center">
                          <div>
                            Kredit
                          </div>
                          <!-- <div class="ml-auto">
                            {{ add_total_kredit | price }}
                          </div> -->
                        </div>
                      </th>
                    </tr>
                    <tr v-for="(item, index) in detail.coa" :key="index" @click="selected.add = (((`100${index}`) + index) + (index+1))" :class="selected.add === (((`100${index}`) + index) + (index+1)) ? 'selected' : ''">
                      
                      <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 150px; min-width: 150; max-width: 150px; text-align: center;">{{ item.pengajuan_coa_coa_number }}</td>
                      <td style="font-size: 12px; border: 1px solid #ededed; width: 210px; min-width: 210px; max-width: 210px; border-left: none; padding: 8px 12px; text-align: left;">
                        {{ item.pengajuan_coa_coa_name }}
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150px; max-width: 150px; padding: 8px 12px; text-align: right;">
                        <div>
                          {{ item.pengajuan_coa_debit | price }}
                        </div>
                      </td>
                      <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150px; max-width: 150px; padding: 8px 12px; text-align: right;">
                        <div>
                          {{ item.pengajuan_coa_kredit | price }}
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <v-divider class="my-4"></v-divider>
              <div>
                <div class="fs-14 mt-1 font-weight-bold">
                  Data Barang
                </div>
                <v-card flat>
                  <v-card-text class="py-0 px-0">

                    <div class="view mt-1">
                      <div class="wrapper_add">
                        <table style="border: 1px solid #ededed; width: 100%;" class="table">
                          <tr>
                            <th style="font-size: 14px; z-index: 1; width: 210px; min-width: 210px; max-width: 210px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Nama</th>
                            <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">
                              <!-- <div class="d-flex align-center">
                                <div>
                                  Qty
                                </div> -->
                                <!-- <div class="ml-auto">
                                  {{ add_total_debit | price }}
                                </div> -->
                              <!-- </div> -->
                               Qty
                            </th>
                            <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">
                              <!-- <div class="d-flex align-center">
                                <div> -->
                                  Nominal
                                <!-- </div> -->
                                <!-- <div class="ml-auto">
                                  {{ add_total_kredit | price }}
                                </div> -->
                              <!-- </div> -->
                            </th>
                            <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">
                              <!-- <div class="d-flex align-center">
                                <div> -->
                                  Supplier
                                <!-- </div> -->
                                <!-- <div class="ml-auto">
                                  {{ add_total_kredit | price }}
                                </div> -->
                              <!-- </div> -->
                            </th>
                            <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              <div class="d-flex align-center">
                                <div>
                                  Keterangan
                                </div>
                                <!-- <div class="ml-auto">
                                  {{ add_total_kredit | price }}
                                </div> -->
                              </div>
                            </th>
                          </tr>
                          <tr v-for="(item, index) in detail.detail" :key="index">
                            <td style="font-size: 12px; border: 1px solid #ededed; width: 100%; border-left: none; padding: 8px 12px; text-align: left;">
                              {{ item.pengajuan_detail_item_name }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150px; max-width: 150px; padding: 8px 12px; text-align: right;">
                              {{ item.pengajuan_detail_item_qty }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150px; max-width: 150px; padding: 8px 12px; text-align: right;">
                              {{ item.pengajuan_detail_item_nominal | price }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 250px; min-width: 250px; max-width: 250px; padding: 8px 12px; text-align: right;">
                              {{ item.pengajuan_detail_supplier === '' ? '-' : item.pengajuan_detail_supplier}}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 400px; min-width: 400px; max-width: 400px; padding: 8px 12px; text-align: left;">
                              {{ item.pengajuan_detail_note }}
                            </td>
                          </tr>
                        </table>
                        <v-card-text
                          v-if="detail.detail.length === 0"
                          class="pb-0 my-4" style="height: calc( 100vh - 600px ); display: flex; align-items: center; justify-content: center;">
                          <div class="text-center">
                            <v-img 
                              class="mx-auto"
                              contain
                              alt="vuetify"
                              :width="90"
                              :height="90"
                              :src="require('@/assets/image/empty.png')">
                              <!-- <template v-slot:placeholder>
                                <v-row
                                  class=" "
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template> -->
                            </v-img>
                            <div class="mt-3 fs-16">
                              Belum Ada Barang Pengajuan
                            </div>
                          </div>
                        </v-card-text>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-card-text>
            
            <v-divider 
            class="mt-2"
            style="border-top: 2px dashed #e0e0e0;"/>
            
            <v-card-actions
            class="pa-4">
              <div v-if="message.error.length > 0"
                class="text-left">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
              <v-spacer/>

              <v-btn
                @click="dialog.approval = true;"
                :loading="process.form"
                :disabled="process.form"
                v-if="detail.status === 'coa'"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Verifikasi
              </v-btn>

              <!-- <v-btn
                @click="dialog.delete = true;"
                :loading="process.form"
                :disabled="process.form"
                v-if="detail.status === 'terupdate'"
                width="120"
                elevation="0"
                color="orange"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Tolak
              </v-btn> -->

              <v-btn
                @click="dialog.detail = false; detail = {};"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pa-8 pt-6">
            <v-card-title 
              class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
              
              Tolak Data

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <!-- <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
              Apakah Anda yakin menolak data <b class="font-weight-bold black--text">Pengajuan</b> yang Anda pilih?

              <div v-if="message.error.length > 0"
                class="text-center mt-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>


            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="pa-0 pt-4">
              <v-spacer/>

              <v-btn
                rounded
                @click="approvals()"
                :loading="process.delete"
                :disabled="process.delete"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Ya, Tolak
              </v-btn>

              <!-- <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.approval"
          @keydown.esc="dialog.approval = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pa-8 pt-6">
            <v-card-title 
              class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
              
              Approval Data

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.approval = false; dialog.fullscreen = false; selected.approval = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.approval = false; dialog.fullscreen = false; selected.approval = [];"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <!-- <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
              Apakah Anda untuk verifikasi data <b class="font-weight-bold black--text">Pengajuan</b> yang Anda pilih?

              <div v-if="message.error.length > 0"
                class="text-center mt-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>


            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="pa-0 pt-4">
              <v-spacer/>

              <v-btn
                rounded
                @click="approvals()"
                :loading="process.approval"
                :disabled="process.approval"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Ya, Yakin
              </v-btn>

              <!-- <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>

          <!-- <div class="d-flex mb-3">
            <div>
              <div class="fs-22 color-dark-blue font-weight-medium">
                Data Invoice Customer
              </div>
            </div>
            <v-spacer />
            <div>
              <v-btn
                color="#1814F3"
                width="195"
                height="50"
                elevation="0"
                style="border-radius: 9px;"
                to="/finance/invoice/add"
                class="fs-16 white--text text-capitalize">
                <v-icon size="18" class="mr-1 pt-1">mdi-plus</v-icon>
                Tambah Invoice
              </v-btn>
            </div>
          </div> -->

        <v-card 
          flat
          class="ma-4 mt-0 box-shadow pb-5"
          style="border-radius: 10px;">

          <v-row
            class="pa-4 py-0">
            <v-col
              cols="12"
              md="7">
              <span
                class="fs-16 black--text ml-2"
                style="font-weight: 600;">
                Data Akunting Pengajuan barang
              </span>
              <!-- <div
                class="body-2">
                Perbandingan SP2D 

                <span v-if="filter.year !== '' && filter.year !== null">
                  tahun <strong class="black--text">{{ filter.year }}</strong>
                </span>

                <span v-if="filter.month !== '' && filter.month !== null">
                  di bulan <strong class="black--text">{{ filter.month_text }}</strong>
                </span>
              </div> -->
            </v-col>
            <v-col cols="12">
              <div>
                <v-tabs
                  v-model="tabs"
                  dense
                  background-color="transparent"
                  slider-size="5"
                  v-on:change="tabs === 1 ? fetchSemuaPengajuan() : fetch()"
                  color="#1814F3">
                  <v-tab
                    v-for="(item, index) in tab"
                    :key="index">
                    <span
                      class="body-2 font-weight-medium text-capitalize">
                      {{ item.title }}
                    </span>
                  </v-tab>
                </v-tabs>
                <v-divider style="border-color: #EBEEF2;"></v-divider>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="12"
              class="d-flex align-center">
              <!-- <v-btn
                color="#4B4B4B"
                elevation="0"
                :disabled="process.load"
                @click="dialog.form = true; reset();"
                class="body-2 white--text text-capitalize d-flex align-center ml-0"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                
                <span
                  class="ml-2">
                  Tambah
                </span>
              </v-btn> -->
              <div v-if="tabs === 1">
                <v-autocomplete
                  v-model="selected_status"
                  :items="[
                    {
                      title: 'Semua Pengajuan',
                      id: ''
                    },
                    {
                      title: 'Approval Atasan',
                      id: 'approval1'
                    },
                    {
                      title: 'Ditolak Atasan',
                      id: 'ditolak1'
                    },
                    {
                      title: 'Proses Update Harga & Pilih Supplier',
                      id: 'terupdate'
                    },
                    {
                      title: 'Approval General Manager',
                      id: 'approval2'
                    },
                    {
                      title: 'Ditolak General Manager',
                      id: 'ditolak2'
                    },
                    {
                      title: 'Penerimaan Gudang',
                      id: 'penerimaan'
                    },
                    {
                      title: 'Kasir',
                      id: 'coa'
                    },
                    {
                      title: 'Pembukuan',
                      id: 'verifikasi'
                    },
                    {
                      title: 'Approval Manager Keuangan',
                      id: 'approval3'
                    },
                    {
                      title: 'Ditolak Manager Keuangan',
                      id: 'tolak3'
                    },
                    {
                      title: 'Approval General Manager',
                      id: 'approval4'
                    },
                    {
                      title: 'Ditolak General Manager',
                      id: 'ditolak4'
                    },
                    {
                      title: 'Print',
                      id: 'print'
                    },
                  ]"
                  item-text="title"
                  item-value="id"
                  hide-details
                  @change="fetchSemuaPengajuan()"
                  filled
                  rounded
                  dense
                  class="fs-12 little-placeholder"

                  color="#718EBF"
                  placeholder="Status Pengajuan"

                  
                  :item-color="set_color"
                  style="border-radius: 6px; background: #d9e8ff9c !important; width: 220px">
                  <!-- <template v-slot:selection="{ item }">
                    <v-chip
                      v-if="item"
                      label
                      close
                      @click:close="selected_status = null">
                      {{ item.title }}
                    </v-chip>
                  </template> -->
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content class="fs-12">{{ data.item.title }}</v-list-item-content>
                    </template>
                  </template>

                </v-autocomplete>
              </div>
              <v-text-field
                @click:clear="search = ''; fetch();"
                v-on:keyup.enter="fetch()"

                filled
                rounded
                dense
                single-line

                hide-details
                :color="set_color"
                placeholder="Cari data yang Anda butuhkan . . ."
                append-icon="mdi-magnify"
                clearable

                v-model="search"
                class="ml-3 fs-12 little-placeholder"
                style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
              </v-text-field>

              <!-- FREEZE COLUMN -->
              <!-- <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.freeze = true">
                      <v-icon size="18">mdi-table-split-cell</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Freeze
                  </span>
                </v-tooltip>
              </div> -->

              <!-- HIDE COLUMN -->
              <!-- <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.hide = true">
                      <v-icon size="18">mdi-eye-off-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Hide
                  </span>
                </v-tooltip>
              </div> -->
            </v-col>
          </v-row>

          <v-card 
            flat
            class="mt-0 mx-5"
            style="border-radius: 25px; border: 1px solid #E7E7E7;">
            <!-- :height="`calc(100vh - ${pagination.total_data > 0 ? '320px' : '148px'})`" -->
            <div class="view">
              <div v-if="!process.load" :class="process.load || list.length === 0 ? '' : 'wrapper'">
                <table style="border-radius: 10px; width: 100%;" class="table">
                  <tr>
                    <th class="sticky-col one-col" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">Aksi</th>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">No. Pengajuan</th>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">Tgl. Jatuh Tempo</th>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">Judul</th>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">Diinput Oleh</th>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 100px;; text-align: left;">Tgl. Input</th>
                    <!-- <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;"></th> -->
                    <!-- <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">Realisasi</th>
                    <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Selisih</th> -->
                  </tr>
                  <tr v-for="(item, index) in list" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                    <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 120px; min-width: 120px; max-width: 120px; padding: 8px 12px; text-align: center;">
                      <v-tooltip 
                        top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="dialog.detail = true; fetchDetail(item.id);"
                            
                            v-bind="attrs"
                            v-on="on"
                            
                            min-width="28"
                            small
                            rounded
                            color="green"
                            elevation="0"
                            class="white--text text-capitalize mx-1 px-0"
                            style="font-weight: 600; border-radius: 6px;">
                            <v-icon small>mdi-information-outline</v-icon>
                          </v-btn>
                        </template>
  
                        <span>Detail</span>
                      </v-tooltip>

                      <!-- <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="toDelete(item.id)"

                              v-bind="attrs"
                              v-on="on"

                              min-width="28"
                              small
                              rounded
                              color="red"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </template>
                          
                          <span>Hapus</span>
                        </v-tooltip> -->
                    </td>
                    <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; border-left: none; width: 1px; white-space: nowrap; text-align: left;">{{ item.number }}</td>
                    <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.due_date | date }}</td>
                    <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.title }}</td>
                    <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.input_user_name }}</td>
                    <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; min-width: 100px;; text-align: left;">{{ item.input_datetime | datetime }}</td>
                    
                    <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">{{ (item.realisasi*1) | price }}</td> -->
                    <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">
                      {{ ((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' :((item.nominal*1) + (item.nominal_sp2b*1)) > (item.realisasi*1) ? '-' : '+'}}
                      {{ (((item.nominal*1) + (item.nominal_sp2b*1)) - (item.realisasi*1)) | price }}
                    </td> -->
                  </tr>
                </table>
              </div>

              <v-card-text
                v-if="process.load" 
                class="pb-0 my-4" 
                style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                <div class="text-center">
                  <div class="mb-4 title">
                    Mohon Tunggu . . .
                  </div>

                  <v-progress-linear
                    :color="set_color"
                    indeterminate
                    rounded
                    height="10">
                  </v-progress-linear>
                </div>
              </v-card-text>

              <v-card-text
                v-if="list.length === 0"
                class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                <div class="text-center">
                  <v-img 
                    class="mx-auto"
                    contain
                    alt="vuetify"
                    :width="90"
                    :height="90"
                    :src="require('@/assets/image/empty.png')">
                    <!-- <template v-slot:placeholder>
                      <v-row
                        class=" "
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template> -->
                  </v-img>
                  <div class="mt-3 fs-16">
                    Belum Ada Data
                  </div>
                </div>
              </v-card-text>

              <pagination v-if="!process.load && pagination.total_data > 0"
                @changePage="tabs === 1 ? fetchSemuaPengajuan($event) : fetch($event)" 
                @reloadPage="tabs === 1 ? fetchSemuaPengajuan($event) : fetch($event)" 
                :model="pagination" :display="paginationList"/>

            </div>


            <!-- <pagination v-if="pagination.total_data > 0"
              @changePage="fetch($event)" 
              @reloadPage="fetch($event)" 
              :model="pagination"/> -->
          </v-card>
        </v-card>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        tabs: 0,
        tab: [
          {
            title: 'Pengajuan',
            id: 'coa'
          },
          {
            title: 'Semua Pengajuan',
            id: 'all'
          },
          // {
          //   title: 'Ditolak',
          //   id: 'ditolak2'
          // },
        ],
        selected_status: '',

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          filter: false,

          form: false,
          delete: false,
          detail: false,
          approval: false
        },
        
        search: '',

        filter: {
          year: new Date().getFullYear()
        },
      sortBy: 'id',
      sortDesc: '-',
      detail: {},

        selected: {
          freeze: [],
          delete: [],
          row: [],
          add: '',
          approval: []
        },

        sales: [],

        form: {
          id: '',
          title: '',
          due_date: '',
          items_arr: []
        },

        options: {},
        headers: [],
        list: [],
        pagination: {},
      paginationList: {},

        lastIndex: 0,
        limit: 50,

        process: {
          load: false,
          detail: false,
          delete: false,
          approval: false,
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
    },
    watch: {
      // 'options': {
      //   handler () {
      //     let pagination = { row: this.limit, page: 1 }
          
      //     this.fetch(pagination)
      //   },
      //   deep: true
      // }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    mounted () {
      this.fetch()
  },
  methods: {
    async fetchSemuaPengajuan (pagination = { row: 50, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row
        this.paginationList = pagination

        let params = {
          status: this.selected_status === 'all' ? '' : this.selected_status,
          // is_delivery: '0',
          limit: pagination.row,
          page: pagination.page,
          sort: `${this.sortDesc}${this.sortBy}`,
          // sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortDesc[0] ? `-${this.options.sortBy[0]}` : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,
          // unit_id: this.$store.state.user.unit_id === '0' || this.$store.state.user.unit_id === 0 ? '' : this.$store.state.user.unit_id
        }

        this.selected.row = []

        // admin/services/data
        
        await get(`admin/pengajuan/data`, { params })
        .then(response => {
          let res = response.data
          
          this.process.load = false
          
          this.list = []
          this.pagination = {}
          
          if (res.status === 200) {
            this.headers = [
              {
                text: '',
                width: '80px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'start',
                format: 'action'
              },
              {
                text: 'No',
                width: '80',
                value: 'index',
                freeze: true,
                hide: false
              },
              {
                text: 'No. Invoice',
                width: '200px',
                value: 'number',
                freeze: true,
                hide: false
              },
              {
                text: 'No. BPB',
                width: '180px',
                value: 'bpb_number',
                freeze: false,
                hide: false
              },
              {
                text: 'Total Tagihan',
                width: '200px',
                value: 'sub_total',
                freeze: false,
                hide: false,
                format: 'number'
              },
              // {
              //   text: 'Biaya Pengiriman',
              //   width: '200px',
              //   value: 'biaya_kirim',
              //   freeze: false,
              //   hide: false,
              //   format: 'number'
              // },
              {
                text: 'Tanggal Jatuh Tempo',
                width: '250px',
                value: 'due_date',
                freeze: false,
                hide: false,
                format: 'date'
              },
              // {
              //   text: 'Status',
              //   width: '150px',
              //   value: 'status',
              //   freeze: false,
              //   hide: false,
              //   format: 'status'
              // },
              // {
              //   text: 'No. BPB',
              //   width: '180px',
              //   value: 'bpb_number',
              //   freeze: false,
              //   hide: false
              // }
            
            ]
    
            this.list = res.results.data
            this.pagination = res.results.pagination

            // this.list.map(obj => {
            //   obj.is_active = obj.is_active === 'Aktif' ? true : false
            // })

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1


            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },
    async fetchDetail (id) {
      this.process.detail = true

      let params = {
        id: id
      }

      await get(`admin/pengajuan/detail`, { params })
      .then(response => {
        let res = response.data
          
        if (res.status === 200) {
          this.detail = res.results.data
          
        }
        this.process.detail = false
      })
    },
    toSort(name) {
      this.sortBy = name
      this.sortDesc = ''
      this.fetch()
    },
    toDesc() {
      this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
      this.fetch()
    },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = (value*1)
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          // let regex = /(<([^>]+)>)/ig

          // data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },

      async fetch (pagination = { row: 50, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row
        this.paginationList = pagination

        let params = {
          status: this.tab[this.tabs].id,
          // is_delivery: '0',
          limit: pagination.row,
          page: pagination.page,
          sort: `${this.sortDesc}${this.sortBy}`,
          // sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortDesc[0] ? `-${this.options.sortBy[0]}` : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,
          // unit_id: this.$store.state.user.unit_id === '0' || this.$store.state.user.unit_id === 0 ? '' : this.$store.state.user.unit_id
        }

        this.selected.row = []

        // admin/services/data
        
        await get(`/admin/pembayaran_barang/data`, { params })
        .then(response => {
          let res = response.data
          
          this.process.load = false
          
          this.list = []
          this.pagination = {}
          
          if (res.status === 200) {
            this.headers = [
              {
                text: '',
                width: '80px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'start',
                format: 'action'
              },
              {
                text: 'No',
                width: '80',
                value: 'index',
                freeze: true,
                hide: false
              },
              {
                text: 'No. Invoice',
                width: '200px',
                value: 'number',
                freeze: true,
                hide: false
              },
              {
                text: 'No. BPB',
                width: '180px',
                value: 'bpb_number',
                freeze: false,
                hide: false
              },
              {
                text: 'Total Tagihan',
                width: '200px',
                value: 'sub_total',
                freeze: false,
                hide: false,
                format: 'number'
              },
              // {
              //   text: 'Biaya Pengiriman',
              //   width: '200px',
              //   value: 'biaya_kirim',
              //   freeze: false,
              //   hide: false,
              //   format: 'number'
              // },
              {
                text: 'Tanggal Jatuh Tempo',
                width: '250px',
                value: 'due_date',
                freeze: false,
                hide: false,
                format: 'date'
              },
              // {
              //   text: 'Status',
              //   width: '150px',
              //   value: 'status',
              //   freeze: false,
              //   hide: false,
              //   format: 'status'
              // },
              // {
              //   text: 'No. BPB',
              //   width: '180px',
              //   value: 'bpb_number',
              //   freeze: false,
              //   hide: false
              // }
            
            ]
    
            this.list = res.results.data
            this.pagination = res.results.pagination

            // this.list.map(obj => {
            //   obj.is_active = obj.is_active === 'Aktif' ? true : false
            // })

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1


            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },


      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: index !== undefined ? this.list[index].id : '',
          title: index !== undefined ? this.list[index].title : '',
          due_date: index !== undefined ? this.list[index].due_date : '',
          items_arr: index !== undefined ? this.list[index].items_arr : []
          // is_active: index !== undefined ? this.list[index].is_active === 'Aktif'? 1 : 0 : 1
        }

        this.process.form = false

        this.message.error = ''
      },

      updateStatus (item) {
        this.selected.row = [item]

        this.dialog.form = true
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'admin/pengajuan/add' : 'admin/pengajuan/update'

          // SAVE TO REST API
          await post(url, {
            data: {
              id: this.form.id,
              title: this.form.title,
              due_date: this.form.due_date,
              items_arr: JSON.stringify(this.form.items_arr)
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      async approvals () {
        this.message.error = ''

        this.process.delete = true
        this.process.approval = true

        await post(`admin/pembayaran_barang/verifikasi`, {
          data: {
            pengajuan_id: this.detail.id,
            // status: this.dialog.approval ? 'approval2' : 'ditolak2'
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false
          this.process.approval = false

          if (res.status === 200) {
            if(this.detail.method_payment === 'cod') {

              // this.dialog.approval = false
              // this.dialog.delete = false
              // this.dialog.detail = false
  
              // this.selected.row = []
              // this.selected.approval = []
              
              // this.dialog.snackbar = true
              // this.message.success = res.message
  
              // this.dialog.fullscreen = false
              // this.fetchDetail(this.detail.id)
  
              // this.fetch()
  
              this.saveJurnal(res.results.data)
            } else {
              this.dialog.approval = false
              this.dialog.delete = false
              this.dialog.detail = false
  
              this.selected.row = []
              this.selected.approval = []
              
              this.dialog.snackbar = true
              this.message.success = res.message
  
              this.dialog.fullscreen = false
              this.fetchDetail(this.detail.id)
  
              this.fetch()
            }
          } else {
            this.message.error = res.message
          }
        })
      },
      async saveJurnal (get_data) {
        // console.log(get_data)
        get_data.data_array = JSON.parse(get_data.data_array)
        let coa = []
        get_data.data_array.map(item => {
          coa.push({
            id: item.coa_id,
            number: item.coa_number,
            name: item.coa_name,
            debit: item.debit,
            kredit: item.kredit
          })
        })
        console.log(coa)
        this.message.error = ''

          this.process.form = true
          // this.$emit('input', {
          //   process: this.process.form
          // })

        let url = 'https://apiakunting.aidan.web.id/add',
        data = {
            datetime: get_data.datetime,
            type: 'jurnal umum',
            data_array: coa
          }

        // SAVE TO REST API
        axios.post(url, data, {
          
          headers: {
            Authorization: `Basic T21SYWN1blByb2plY3RGcmVlbGFuY2U6VUNUQWNjb3VudGluZ1Npc3RlbUZvckZyZWVkb20=`
            // token: TokenService.getToken()
          }
        })
        .then(response => {
          let res = response.data
          
          this.process.form = false

          if (res.status === 200) {
            this.dialog.approval = false
            this.dialog.delete = false
            this.dialog.detail = false

            this.selected.row = []
            this.selected.approval = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false
            this.fetchDetail(this.detail.id)

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
        
      },
      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/pengajuan/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      }

    }
  }
</script>

<style>
  /* ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #F5F5F5;
  }
  ::-webkit-scrollbar-track{
    background-color: #F5F5F5;
    border-radius: 10px;
  } */
  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #718EBF;
  }
  table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  /* width: 100%; */
}

.wrapper { 
  overflow-y: auto; 
  height: calc(100vh - 390px); 
} 

.wrapper-none { 
  /* overflow-y: auto; 
  height: calc(100vh - 270px);  */
} 

.wrapper th { 
  position: sticky; 
  top: 0; 
  background-color: white !important;
} 
.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  background-color: white !important;
}

.one-col {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  left: 0px;
}

.second-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 150px;
}

.three-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 300px;
}

.four-col {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  left: 450px;
}

tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>